/**
 * store / code.js
 * 
 * vue js code 목록들
 * 
 */


const state = {
  allCodeList         : [],   // 전체 코드 목록
  nationCodeList      : [],
  cityCodeList        : [],
  regionCodeList      : [],
  orderStatusCodeList : [],   // Order 상태
  consolStatusCodeList: [],   // 콘솔상태
  bizTypeCodeList     : [],   // 파트너 비지니스 타입
  authLevelList       : [],   // 멤버 권한 목록
  freightList         : [],   // 멤버 권한 목록
  seqTypeList         : [],   // 시퀀스 타입목록
  brdTypeList         : [],   // 시퀀스 타입목록
}

/**
 * 
 * 게터 - getters
 * 
 * 각 코드 목록을 label, value 형태로 변환하여 반환
 *
 * @returns {Object} 변환된 코드 목록
 */
const getters = {
  getNationCodeList : (state) => {
    let nationList = state.nationCodeList
      .filter(item => Number(item.status) === 0)
      .map(item => {
      return { label : item.codeLabel, value : item.value }
    })
    
    return nationList
  },

  getCityCodeList : (state) => {
    let cityList = state.cityCodeList.map(item => {
      return { label : item.codeLabel, value : item.value }
    })
    
    return cityList
  },

  getRegionCodeList : (state) => {
    let regionList = state.regionCodeList.map(item => {
      return { label : item.codeLabel, value : item.value }
    })
    
    return regionList
  },

  getOrderStatusCodeList : (state) => {
    let orderStatusList = state.orderStatusCodeList.map(item => {
      return { label : item.codeLabel, value : item.value }
    })
    
    return orderStatusList
  },

  /** 진행상태 */
  getConsolStatusList(state) {
    let consolStatusCodeList = state.consolStatusCodeList.map(item => {
      return ({ label : item.codeLabel, value : item.value })
    })

    return consolStatusCodeList
  },

  /** 파트너 비지니스 타입 */
  getBizTypeCodeList(state) {
    let bizTypeCodeList = state.bizTypeCodeList.map(item => {
      return ({ label : item.codeLabel, value : item.value })
    })

    return bizTypeCodeList
  },

  /** 멤버 권한 목록 */
  getAuthLevelList(state) {
    let authLevelList = state.authLevelList.map(item => {
      return { label : item.codeLabel, value : item.value }
    })
    
    return authLevelList
  },

  /** 국가 목록 */
  getNationList(state) {
    let nationList = state.nationCodeList.map(item => {
      return { label : item.codeLabel, value : item.value }
    })
    
    return nationList
  },

  /** Freight 목록 */
  getFreightList(state) {
    let freightList = state.freightList.map(item => {
      return { label : item.codeLabel, value : item.value }
    })
    
    return freightList
  },

  /** 시퀀스 타입 목록 */
  getSeqTypeList(state) {
    let seqTypeList = state.seqTypeList.map(item => {
      return { label : item.codeLabel, value : item.value }
    })
    
    return seqTypeList
  },

  /** 게시판 타입 목록 */
  getBrdTypeList(state) {
    let brdTypeList = state.brdTypeList.map(item => {
      return { label : item.codeLabel, value : item.value }
    })
    
    return brdTypeList
  },
}

/**
 * 
 * 뮤테이션 - mutations
 * 
 */
const mutations = {
  mutateNationList(state, value){
    state.nationCodeList = value
  },
  mutateCityList(state, value){
    state.cityCodeList = value
  },
  mutateRegionList(state, value){
    state.regionCodeList = value
  },
  mutateOrderStatusList(state, value){
    state.orderStatusCodeList = value
  },
  mutateConsolStatusList(state, value){
    state.consolStatusCodeList = value
  },
  mutateBizTypeList(state, value){
    state.bizTypeCodeList = value
  },
  mutateAuthLevelList(state, value){
    state.authLevelList = value
  },
  mutateFreightList(state, value){
    state.freightList = value
  },
  mutateSeqTypeList(state, value){
    state.seqTypeList = value
  },
  mutateBrdTypeList(state, value){
    state.brdTypeList = value
  },
  /**
   * 
   * 전체 코드 목록을 설정
   * 
   * @param {Object} state - Vuex state
   * @param {Array} value - 전체 코드 목록
   */
  mutateAllCodeList(state, value) {
    // log.debug("mutateAllCodeList executed => ", value)
    state.allCodeList = value
  }
}





/**
 * 
 * 액션 - actions
 * 
 */
const actions = {
  // 국가코드 입력
  actNationList({commit}, payload){
    commit('mutateNationList', payload)
  },

  actCityList({commit}, payload){
    commit('mutateCityList', payload)
  },

  actRegionList({commit}, payload){
    commit('mutateRegionList', payload)
  },

  actOrderStatusList({commit}, payload){
    commit('mutateOrderStatusList', payload)
  },

  actConsolStatusList({commit}, payload){
    commit('mutateConsolStatusList', payload)
  },

  actBizTypeList({commit}, payload){
    commit('mutateBizTypeList', payload)
  },

  actAuthLevelList({commit}, payload){
    commit('mutateAuthLevelList', payload)
  },

  actFreightList({commit}, payload){
    commit('mutateFreightList', payload)
  },

  actSeqTypeList({commit}, payload){
    commit('mutateSeqTypeList', payload)
  },

  actBrdTypeList({commit}, payload){
    commit('mutateBrdTypeList', payload)
  },
}


// state, getters, mutations, actions, modules
export default {

  state: {
    ...state
  },
  getters,
  mutations,
  actions

}
